import React from 'react';
const IconRejected = ({color = '#FF333B'}) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 1.333a6.667 6.667 0 1 1 0 13.334A6.667 6.667 0 0 1 8 1.333zm0 1.334A5.34 5.34 0 0 0 2.667 8 5.34 5.34 0 0 0 8 13.333 5.34 5.34 0 0 0 13.333 8 5.34 5.34 0 0 0 8 2.667zm1.862 2.528a.667.667 0 0 1 .88-.055l.063.055c.26.26.26.683 0 .943L8.943 8l1.862 1.862c.24.24.259.618.055.88l-.055.063a.666.666 0 0 1-.943 0L8 8.943l-1.861 1.862a.666.666 0 0 1-.385.19L5.667 11a.666.666 0 0 1-.471-1.138L7.057 8 5.196 6.138a.667.667 0 0 1-.056-.88l.056-.063.062-.055a.667.667 0 0 1 .88.055L8 7.057z" fill={color} fillRule="evenodd"/>
    </svg>
  )
}
export default IconRejected;
